module.exports = __webpack_public_path__ + "static/media/cmu.8e62c01d.jpg";